import { ImageFallback, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

interface ProductInfoProps {
  productName: string;
  managerImage: string;
  productTypeName: string;
}
export const ProductInfoDesktop: React.FC<ProductInfoProps> = ({
  productName,
  managerImage,
  productTypeName,
}) => {
  return (
    <>
      <HStack alignItems="center" justifyContent="space-between">
        <Text
          fontSize={Typography['fontsize.lg']}
          variant="semibold"
          color="brand.primary.principal">
          Bloqueio de {productName}
        </Text>
      </HStack>
      <HStack
        bg={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.3)}
        alignItems="center"
        justifyContent="space-between"
        mt={Spacing['stack.xs']}
        px={Spacing['inline.xxs']}
        py={Spacing['stack.xxxs']}>
        <VStack alignItems="center" justifyContent="center" space={Spacing['stack.nano']}>
          <Text
            fontSize={Typography['fontsize.xs']}
            variant="semibold"
            color="brand.primary.principal">
            Emissor
          </Text>
          <ImageFallback
            src={managerImage}
            alt="logo"
            width="54px"
            height="48px"
            testID="product-img"
            resizeMode="cover"
            borderRadius={BoxRadius.sm}
            resizeMethod="scale"
          />
        </VStack>
        <VStack alignItems="center" justifyContent="center" space={Spacing['stack.nano']}>
          <Text
            fontSize={Typography['fontsize.xs']}
            variant="semibold"
            color="brand.primary.principal">
            Nome
          </Text>
          <Text
            fontSize={Typography['fontsize.xs']}
            variant="regular"
            color="brand.primary.principal">
            {productName}
          </Text>
        </VStack>
        <VStack alignItems="center" justifyContent="center" space={Spacing['stack.nano']}>
          <Text
            fontSize={Typography['fontsize.xs']}
            variant="semibold"
            color="brand.primary.principal">
            Tipo de produto
          </Text>
          <Text
            fontSize={Typography['fontsize.xs']}
            variant="regular"
            color="brand.primary.principal">
            {productTypeName.toUpperCase()}
          </Text>
        </VStack>
      </HStack>
    </>
  );
};
